import { createContext } from 'react'
import { FilterContext } from '../definitions'

export const FiltersContext = createContext<FilterContext<unknown>>(null)
export const FiltersContextProvider = FiltersContext.Provider
